/* unplugin-vue-components disabled */import script from "./bread-crumb.vue?vue&type=script&setup=true&lang=js"
export * from "./bread-crumb.vue?vue&type=script&setup=true&lang=js"

import "./bread-crumb.vue?vue&type=style&index=0&id=50c73be8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50c73be8"]])

export default __exports__